import { apiConcurso } from './cliente';

// ── Jurados ──

export const salvarCadastroJurado = (data) => apiConcurso.post('/api/v1/jurados', data);

export const obterFormularioAtualJurado = () => apiConcurso.get('/api/v1/jurados/formulario-atual');

export const obterMesasJurado = () => apiConcurso.get('/api/v1/jurados/me/mesas');

export const obterAgendaJurado = () => apiConcurso.get('/api/v1/jurados/me/agenda');

/**
 * Obtém o certificado do jurado no concurso vigente.
 * Retorna dados do certificado (template, disponível, etc.) ou 404 se não disponível.
 */
export const obterCertificadoJurado = () => apiConcurso.get('/api/v1/jurados/me/certificado');

/**
 * Baixa o PDF do certificado do jurado.
 * Retorna blob do PDF ou 404 se não disponível.
 */
export const baixarCertificadoJurado = () =>
  apiConcurso.get('/api/v1/jurados/me/certificado/pdf', { responseType: 'blob' });

// ── Convites (público) ──

/**
 * Obtém dados públicos de um convite (sem autenticação).
 * Usado na landing page do convite para validar e pré-preencher o email.
 */
export const obterDadosPublicosConvite = (conviteJuradoId) =>
  apiConcurso.get(`/api/v1/jurados/convites/${conviteJuradoId}/publico`);

// ── Backoffice - Jurados ──

export const listarJuradosConcurso = (concursoId, params) =>
  apiConcurso.get(`/api/v1/backoffices/jurados/concursos/${concursoId}`, { params });

// Rota pública do convidado (a de revogar, do backoffice, é só de admin)
export const recusarConviteJurado = (conviteJuradoId) =>
  apiConcurso.post(`/api/v1/jurados/convites/${conviteJuradoId}/recusar`);

// ── Jurado - Mesas ──

export const listarMinhasMesas = () => apiConcurso.get('/api/v1/avaliacao/mesas');

export const obterMesa = (mesaId) => apiConcurso.get(`/api/v1/avaliacao/mesas/${mesaId}`);

// ── Jurado - Avaliação ──

export const obterFichaAvaliacao = (mesaId, produtoId) =>
  apiConcurso.get(`/api/v1/avaliacao/mesas/${mesaId}/produtos/${produtoId}/ficha`);

export const salvarNotas = (mesaId, produtoId, data) =>
  apiConcurso.post(`/api/v1/avaliacao/mesas/${mesaId}/produtos/${produtoId}/notas`, data);

/** Resolve um código cego (4 dígitos) pro produtoId real do concurso vigente. */
export const resolverCodigoCego = (codigo) => apiConcurso.get(`/api/v1/fases/mesas/codigo-cego/${codigo}`);
